import { APICore } from './apiCore'

const api = new APICore()

function getDevicesGroups (params) {
  const baseUrl = '/devices-groups'
  return api.get(baseUrl, params)
}

function getDevicesGroup (id) {
  const baseUrl = `/devices-groups/${id}`
  return api.get(baseUrl, {})
}

function addDevicesGroup (params) {
  const baseUrl = '/devices-groups'
  return api.create(baseUrl, params)
}
function updateDevicesGroup (params) {
  const baseUrl = '/devices-groups'
  return api.update(baseUrl, params)
}
function deleteDevicesGroup (params) {
  const baseUrl = '/devices-groups'
  return api.delete(baseUrl, params)
}

export { getDevicesGroups, getDevicesGroup, addDevicesGroup, updateDevicesGroup, deleteDevicesGroup }